import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  no: {
    translation: {
      // Navigation
      nav: {
        adsiDevelop: "Adsi Develop",
        privacy: "Personvern",
        terms: "Vilkår",
        contact: "Kontakt",
        admin: "Admin",
        back: "Tilbake"
      },
      // Landing page
      landing: {
        heroTitle: "Et stille rom for",
        heroTitleHighlight: "dine tanker",
        heroDescription: "Mindary er din personlige terapidagbok for selvrefleksjon- og innsikt.",
        getStarted: "Kom i gang",
        whyMindary: "Hvorfor mindary?",
        whyMindaryDesc: "Vi har skapt et verktøy som setter din mentale helse først.",
        features: {
          dailyReflection: "Daglig Refleksjon",
          dailyReflectionDesc: "Skriv ned tankene dine i et trygt og privat rom. Dagbok-skriving kan hjelpe deg med å forstå følelsene dine bedre.",
          insight: "Innsikt",
          insightDesc: "Få verdifull innsikt basert på dine dagbokinnlegg for å støtte din personlige vekst.",
          emotionalAwareness: "Emosjonell Bevissthet",
          emotionalAwarenessDesc: "Spor humøret ditt over tid og oppdag mønstre som påvirker din mentale helse.",
          safePrivate: "Trygt & Privat",
          safePrivateDesc: "Dine tanker er helt dine. Vi prioriterer personvern og sikkerhet i alt vi gjør."
        }
      },
      // Download page
      download: {
        title: "Last ned Mindary",
        subtitle: "Din personlige terapidagbok – alltid tilgjengelig i lommen din",
        availableOn: "Tilgjengelig på begge plattformer",
        downloadDesc: "Last ned Mindary og start din reise mot bedre selvinnsikt",
        appStore: "App Store",
        googlePlay: "Google Play",
        downloadFrom: "Last ned fra",
        availableAt: "Tilgjengelig på",
        safePrivate: "Trygt og privat",
        safePrivateDesc: "Dine data er sikre hos oss",
        withCare: "Utviklet med omsorg",
        withCareDesc: "For din mentale helse"
      },
      // Contact page
      contact: {
        title: "Ta kontakt",
        subtitle: "Har du spørsmål, tilbakemeldinger eller ønsker å vite mer om Mindary?",
        weWantToHear: "Vi hører gjerne fra deg",
        weWantToHearDesc: "Send oss en melding, så kommer vi tilbake til deg så snart som mulig. Vi setter pris på alle tilbakemeldinger og spørsmål.",
        weCare: "Vi bryr oss",
        weCareDesc: "Om din mentale helse og velvære",
        safePrivate: "Trygt og privat",
        safePrivateDesc: "Dine meldinger er trygge hos oss",
        norwegianBased: "Norskbasert",
        norwegianBasedDesc: "Utviklet av Adsi Develop i Norge",
        name: "Navn",
        namePlaceholder: "Ditt navn",
        email: "E-post",
        emailPlaceholder: "din@epost.no",
        message: "Melding",
        messagePlaceholder: "Skriv din melding her...",
        send: "Send melding",
        sending: "Sender...",
        thankYou: "Takk for meldingen!",
        thankYouDesc: "Vi kommer tilbake til deg så snart som mulig.",
        error: "Noe gikk galt",
        errorDesc: "Vennligst prøv igjen senere."
      },
      // Privacy page
      privacy: {
        title: "Personvern",
        subtitle: "Ditt personvern er viktig for oss",
        localStorage: "Lokal datalagring",
        localStorageSubtitle: "Dine data forblir på din enhet",
        localStorageDesc1: "Mindary bruker lokal datalagring på din enhet. Dette betyr at alle dine dagbokinnlegg, refleksjoner og personlige notater lagres direkte på din telefon eller nettbrett – ikke på eksterne servere.",
        localStorageDesc2: "Ved å holde dataene lokalt sikrer vi at du har full kontroll over din egen informasjon. Ingen andre enn deg har tilgang til det du skriver i appen.",
        noSharing: "Ingen ekstern deling",
        noSharingDesc: "Vi deler ikke dine personlige data med tredjeparter. Dine refleksjoner og tanker er helt private.",
        youOwnData: "Du eier dine data",
        youOwnDataDesc: "Du har full kontroll over dine egne data. Du kan når som helst slette innhold fra appen.",
        noTracking: "Ingen sporing",
        noTrackingDesc: "Vi sporer ikke din aktivitet eller samler inn data om hvordan du bruker appen.",
        secureStorage: "Sikker lagring",
        secureStorageDesc: "Dataene dine lagres sikkert på din enhet og er beskyttet av enhetens innebygde sikkerhetsfunksjoner.",
        questions: "Har du spørsmål om personvern?",
        contactUs: "Ta kontakt med oss →"
      },
      // Terms page
      terms: {
        title: "Vilkår og ansvar",
        subtitle: "Viktig informasjon om bruk av Mindary",
        purpose: "Appens formål",
        purposeSubtitle: "Personlig vekst og utvikling",
        purposeDesc1: "Mindary er utviklet for å oppmuntre til personlig vekst og utvikling. Appen er et verktøy for selvrefleksjon som kan hjelpe deg med å utforske dine egne tanker, følelser og mål.",
        purposeDesc2: "Gjennom strukturert dagbokskriving ønsker vi å støtte din reise mot økt selvinnsikt og personlig utvikling.",
        disclaimer: "Viktig ansvarsfraskrivelse",
        disclaimerSubtitle: "Vennligst les nøye",
        disclaimerIntro: "Mindary er ikke et medisinsk verktøy. Appen skal under ingen omstendigheter brukes til å:",
        disclaimerPoint1: "Tolke symptomer på psykisk eller fysisk sykdom",
        disclaimerPoint2: "Diagnostisere helsetilstander",
        disclaimerPoint3: "Behandle psykiske eller fysiske plager",
        disclaimerPoint4: "Gi medisinsk rådgivning",
        professionalHelp: "Profesjonell hjelp",
        professionalHelpSubtitle: "Appen erstatter ikke terapi",
        professionalHelpDesc1: "Mindary erstatter ikke profesjonell terapi eller behandling. Hvis du opplever psykiske utfordringer, angst, depresjon eller andre helseproblemer, anbefaler vi på det sterkeste at du søker hjelp fra kvalifisert helsepersonell.",
        professionalHelpDesc2: "Appen kan brukes som et supplement til profesjonell behandling, men skal aldri erstatte kontakt med lege, psykolog eller annet helsepersonell.",
        recommendedUse: "Anbefalt bruk",
        recommendedUseDesc: "Bruk Mindary til daglig refleksjon, målsetting og personlig journalføring. Appen er designet for å støtte din personlige utvikling.",
        yourResponsibility: "Ditt ansvar",
        yourResponsibilityDesc: "Du er selv ansvarlig for hvordan du bruker appen og for å søke profesjonell hjelp når det er nødvendig.",
        emergencyTitle: "Internasjonale hjelpetelefoner",
        emergencySubtitle: "Ved akutte kriser, kontakt hjelpetelefon i ditt land:",
        questions: "Har du spørsmål om vilkår og ansvar?",
        contactUs: "Ta kontakt med oss →"
      },
      // Adsi Develop page
      adsi: {
        title: "Adsi Develop",
        subtitle: "Teknologi som fremmer helse og velvære",
        aboutUs: "Om oss",
        aboutDesc1: "Adsi Develop er et norskbasert teknologiselskap som utvikler apper med mål om å hjelpe mennesker i hverdagen. Selskapet ble etablert med en tydelig visjon: å fremme god helse på internasjonal basis gjennom innovative og tilgjengelige digitale løsninger.",
        aboutDesc2: "Adsi Develop kombinerer teknologi og menneskelig innsikt for å skape verktøy som styrker mental og fysisk helse. Ved å utvikle brukervennlige applikasjoner ønsker selskapet å gjøre støtte og egenutvikling mer tilgjengelig for alle – uavhengig av bakgrunn og geografisk plassering.",
        healthFirst: "Helse først",
        healthFirstDesc: "Vi setter mental og fysisk helse i sentrum av alt vi gjør.",
        globalAccess: "Global tilgjengelighet",
        globalAccessDesc: "Våre løsninger skal være tilgjengelige for alle, uansett hvor de er.",
        continuousDev: "Kontinuerlig utvikling",
        continuousDevDesc: "Vi jobber alltid mot en mer bevisst, balansert og sunnere verden.",
        mindary: "Mindary",
        mindarySubtitle: "Vår første app",
        mindaryDesc1: "Den første appen som er lansert er Mindary, en terapidagbok utviklet for å hjelpe brukere med å reflektere over egne tanker, følelser og personlige mål.",
        mindaryDesc2: "Mindary er designet som et trygt og strukturert verktøy som kan brukes både selvstendig og i samarbeid med terapeut, og har som mål å styrke selvinnsikt, mestring og psykisk velvære.",
        tryMindary: "Prøv Mindary",
        vision: "Vår visjon",
        visionDesc: "Gjennom kontinuerlig utvikling og et sterkt fokus på helse ønsker Adsi Develop å bidra til en mer bevisst, balansert og sunnere verden – én app om gangen."
      },
      // Footer
      footer: {
        copyright: "© 2025 Adsi Develop. Alle rettigheter reservert."
      },
      // Language
      language: "Språk"
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        adsiDevelop: "Adsi Develop",
        privacy: "Privacy",
        terms: "Terms",
        contact: "Contact",
        admin: "Admin",
        back: "Back"
      },
      // Landing page
      landing: {
        heroTitle: "A quiet space for",
        heroTitleHighlight: "your thoughts",
        heroDescription: "Mindary is your personal therapy journal for self-reflection and insight.",
        getStarted: "Get Started",
        whyMindary: "Why Mindary?",
        whyMindaryDesc: "We have created a tool that puts your mental health first.",
        features: {
          dailyReflection: "Daily Reflection",
          dailyReflectionDesc: "Write down your thoughts in a safe and private space. Journaling can help you understand your feelings better.",
          insight: "Insight",
          insightDesc: "Gain valuable insight based on your journal entries to support your personal growth.",
          emotionalAwareness: "Emotional Awareness",
          emotionalAwarenessDesc: "Track your mood over time and discover patterns that affect your mental health.",
          safePrivate: "Safe & Private",
          safePrivateDesc: "Your thoughts are entirely yours. We prioritize privacy and security in everything we do."
        }
      },
      // Download page
      download: {
        title: "Download Mindary",
        subtitle: "Your personal therapy journal – always available in your pocket",
        availableOn: "Available on both platforms",
        downloadDesc: "Download Mindary and start your journey towards better self-insight",
        appStore: "App Store",
        googlePlay: "Google Play",
        downloadFrom: "Download from",
        availableAt: "Available on",
        safePrivate: "Safe and private",
        safePrivateDesc: "Your data is secure with us",
        withCare: "Developed with care",
        withCareDesc: "For your mental health"
      },
      // Contact page
      contact: {
        title: "Contact Us",
        subtitle: "Do you have questions, feedback, or want to know more about Mindary?",
        weWantToHear: "We'd love to hear from you",
        weWantToHearDesc: "Send us a message and we'll get back to you as soon as possible. We appreciate all feedback and questions.",
        weCare: "We care",
        weCareDesc: "About your mental health and well-being",
        safePrivate: "Safe and private",
        safePrivateDesc: "Your messages are safe with us",
        norwegianBased: "Norwegian based",
        norwegianBasedDesc: "Developed by Adsi Develop in Norway",
        name: "Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "your@email.com",
        message: "Message",
        messagePlaceholder: "Write your message here...",
        send: "Send message",
        sending: "Sending...",
        thankYou: "Thank you for your message!",
        thankYouDesc: "We'll get back to you as soon as possible.",
        error: "Something went wrong",
        errorDesc: "Please try again later."
      },
      // Privacy page
      privacy: {
        title: "Privacy",
        subtitle: "Your privacy is important to us",
        localStorage: "Local data storage",
        localStorageSubtitle: "Your data stays on your device",
        localStorageDesc1: "Mindary uses local data storage on your device. This means that all your journal entries, reflections, and personal notes are stored directly on your phone or tablet – not on external servers.",
        localStorageDesc2: "By keeping the data local, we ensure that you have full control over your own information. No one but you has access to what you write in the app.",
        noSharing: "No external sharing",
        noSharingDesc: "We do not share your personal data with third parties. Your reflections and thoughts are completely private.",
        youOwnData: "You own your data",
        youOwnDataDesc: "You have full control over your own data. You can delete content from the app at any time.",
        noTracking: "No tracking",
        noTrackingDesc: "We do not track your activity or collect data about how you use the app.",
        secureStorage: "Secure storage",
        secureStorageDesc: "Your data is stored securely on your device and is protected by the device's built-in security features.",
        questions: "Do you have questions about privacy?",
        contactUs: "Contact us →"
      },
      // Terms page
      terms: {
        title: "Terms and Responsibility",
        subtitle: "Important information about using Mindary",
        purpose: "App Purpose",
        purposeSubtitle: "Personal growth and development",
        purposeDesc1: "Mindary is developed to encourage personal growth and development. The app is a tool for self-reflection that can help you explore your own thoughts, feelings, and goals.",
        purposeDesc2: "Through structured journaling, we want to support your journey towards increased self-insight and personal development.",
        disclaimer: "Important Disclaimer",
        disclaimerSubtitle: "Please read carefully",
        disclaimerIntro: "Mindary is not a medical tool. The app should under no circumstances be used to:",
        disclaimerPoint1: "Interpret symptoms of mental or physical illness",
        disclaimerPoint2: "Diagnose health conditions",
        disclaimerPoint3: "Treat mental or physical ailments",
        disclaimerPoint4: "Provide medical advice",
        professionalHelp: "Professional Help",
        professionalHelpSubtitle: "The app does not replace therapy",
        professionalHelpDesc1: "Mindary does not replace professional therapy or treatment. If you experience mental health challenges, anxiety, depression, or other health problems, we strongly recommend that you seek help from qualified healthcare professionals.",
        professionalHelpDesc2: "The app can be used as a supplement to professional treatment, but should never replace contact with a doctor, psychologist, or other healthcare professional.",
        recommendedUse: "Recommended Use",
        recommendedUseDesc: "Use Mindary for daily reflection, goal setting, and personal journaling. The app is designed to support your personal development.",
        yourResponsibility: "Your Responsibility",
        yourResponsibilityDesc: "You are responsible for how you use the app and for seeking professional help when necessary.",
        emergencyTitle: "International Helplines",
        emergencySubtitle: "In case of acute crisis, contact the helpline in your country:",
        questions: "Do you have questions about terms and responsibility?",
        contactUs: "Contact us →"
      },
      // Adsi Develop page
      adsi: {
        title: "Adsi Develop",
        subtitle: "Technology that promotes health and well-being",
        aboutUs: "About Us",
        aboutDesc1: "Adsi Develop is a Norwegian-based technology company that develops apps with the goal of helping people in their everyday lives. The company was established with a clear vision: to promote good health on an international basis through innovative and accessible digital solutions.",
        aboutDesc2: "Adsi Develop combines technology and human insight to create tools that strengthen mental and physical health. By developing user-friendly applications, the company wants to make support and self-development more accessible to everyone – regardless of background and geographical location.",
        healthFirst: "Health First",
        healthFirstDesc: "We put mental and physical health at the center of everything we do.",
        globalAccess: "Global Accessibility",
        globalAccessDesc: "Our solutions should be accessible to everyone, no matter where they are.",
        continuousDev: "Continuous Development",
        continuousDevDesc: "We always work towards a more conscious, balanced, and healthier world.",
        mindary: "Mindary",
        mindarySubtitle: "Our first app",
        mindaryDesc1: "The first app launched is Mindary, a therapy journal developed to help users reflect on their own thoughts, feelings, and personal goals.",
        mindaryDesc2: "Mindary is designed as a safe and structured tool that can be used both independently and in collaboration with a therapist, and aims to strengthen self-insight, coping, and mental well-being.",
        tryMindary: "Try Mindary",
        vision: "Our Vision",
        visionDesc: "Through continuous development and a strong focus on health, Adsi Develop wants to contribute to a more conscious, balanced, and healthier world – one app at a time."
      },
      // Footer
      footer: {
        copyright: "© 2025 Adsi Develop. All rights reserved."
      },
      // Language
      language: "Language"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'no', // default language
    fallbackLng: 'no',
    interpolation: {
      escapeValue: false
    }
  });

// Update HTML lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
